import React from 'react';
import { Award } from 'lucide-react';
import { iitResearchers } from '../data/mock';
import { credibilityContent } from '../data/audienceContent';
import { useAudience } from '../contexts/AudienceContext';

const IITCredibilitySection = () => {
  const { audience } = useAudience();
  const copy = credibilityContent[audience];

  return (
    <section className="py-16 bg-gradient-to-r from-blue-900 via-blue-800 to-teal-900 text-white">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-10 lg:gap-12 items-center mb-12">
            <div className="order-2 lg:order-1 rounded-2xl overflow-hidden shadow-2xl border border-white/20 aspect-[4/3] lg:aspect-auto lg:min-h-[280px]">
              <img
                src={copy.imageSrc}
                alt={copy.imageAlt}
                width={1000}
                height={750}
                loading="lazy"
                decoding="async"
                className="w-full h-full min-h-[220px] object-cover"
              />
            </div>
            <div className="order-1 lg:order-2 text-center lg:text-left">
              <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full mb-4">
                <Award className="w-5 h-5 shrink-0" />
                <span className="text-sm font-semibold">{copy.badge}</span>
              </div>
              <h2 className="font-display text-3xl lg:text-4xl font-bold mb-4 tracking-tight">
                {copy.title}
              </h2>
              <p className="text-blue-100 text-lg max-w-xl mx-auto lg:mx-0 leading-relaxed">
                {copy.body}
              </p>
            </div>
          </div>

          <div className="grid md:grid-cols-3 gap-6">
            {iitResearchers.map((researcher) => (
              <div
                key={researcher.id}
                className="bg-white/10 backdrop-blur-md p-6 rounded-2xl border border-white/20 hover:bg-white/15 transition-all duration-300"
              >
                <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center mb-4">
                  <Award className="w-6 h-6 text-white" />
                </div>
                <h3 className="text-xl font-bold mb-2">{researcher.name}</h3>
                <p className="text-blue-200 font-semibold mb-2">{researcher.institution}</p>
                <p className="text-blue-100 text-sm">{researcher.role}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default IITCredibilitySection;
